module.exports = __webpack_public_path__ + "img/img_more.ccfb5d92.png";